import { Middleware, configureStore } from "@reduxjs/toolkit";
import { createInjectorsEnhancer } from "redux-injectors";
import createSagaMiddleware from "@redux-saga/core";
import { createRootReducer } from "./rootReducer";
import { rootSaga } from "./sagas";
import { createLogger } from "redux-logger";

const sagaMiddleware = createSagaMiddleware();
const { run: runSaga } = sagaMiddleware;

const getMiddlewares = () => {
  const middlewares = [sagaMiddleware] as Middleware[];
  
  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
      level: "warn",
    });
    middlewares.push(logger as any);
  }
  
  return middlewares;
};

const enhancers = [
  createInjectorsEnhancer({
    runSaga,
    createReducer: createRootReducer,
  }),
];

const store = configureStore({
  reducer: createRootReducer(),
  middleware: getMiddlewares(),
  enhancers,
});
sagaMiddleware.run(rootSaga);

export { store };
